
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g6eKJk5qICUINES_45ic02Y3D9bZvmREXzRrFdFN3dawaUMeta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexuB7t9RUuPh3TcDBGhGzPkVW4GwYJeWnkCZGKjyTV33YMeta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchaqeb2Z7tgS2UjNZ7mwhAB2k_xF1cP9CtEL3u_qWL7sUMeta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexVNGvZKuBXtU7NjBl3TSEfQbu0ia0lrXvnGW9DE3M6S8Meta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93frInfa4TkGPweboz3R8PJyi3SxiZctOUIMP_r0XRf_450Meta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexYvijyLO_4582HmBghyLKlkL_45jlSrsN5WRKw6rtL7j_45HA4Meta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93iawK9gOUodon8wIhkd7ZOZLngi1vYFKFOppXzX5eqScMeta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexiufqw3WxTPxHH9zcJ8KB8_45I6gEf1T3LbhS_To0Of27EMeta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93pCAZ9atPM2nj1mb2QJJAWbQ191kjyQOesl524F5eV28Meta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexCYA6SY8GVkPxu3VKD2hyY1e49NvYmnP0VeI0b_JNzq8Meta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexFWuNtgRNxxfDiOqZ9d_nO6pnHQrRGIWZ6cygWM_45NpwoMeta } from "/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexYvijyLO_4582HmBghyLKlkL_45jlSrsN5WRKw6rtL7j_45HA4Meta || {},
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexiufqw3WxTPxHH9zcJ8KB8_45I6gEf1T3LbhS_To0Of27EMeta || {},
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexCYA6SY8GVkPxu3VKD2hyY1e49NvYmnP0VeI0b_JNzq8Meta || {},
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexFWuNtgRNxxfDiOqZ9d_nO6pnHQrRGIWZ6cygWM_45NpwoMeta || {},
    component: () => import("/codebuild/output/src2178568092/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]